@if (isNotEmpty(dataTestId)) {
	<a [target]="target" [href]="externalLink | ensureHttp" rel="noopener noreferrer" [attr.data-test-id]="dataTestId">
		@if (isNotEmpty(leftIconClass)) {
			<i class="icon fa fa-{{leftIconClass}}"></i>
		}
		{{ linkDisplayName }}
	</a>
}
